import {
  retry,
  timeout,
  request,
  panthorEndpoint,
  HTTPError,
  TimeoutError,
  getJwtToken,
} from '@fingermarkglobal/request';
import { RestaurantMenuCount, ChromeSerialSettings } from '@fingermarkglobal/types';

const getProductsRequest = async (count: RestaurantMenuCount, settings: ChromeSerialSettings) => {
  const organisationId = process.env.POI_APP_ORGANISATION_ID || null;
  const { storeId: id } = settings.settings.datasource;
  const { numberOfProductsPage: pages } = count;

  try {
    const token = await getJwtToken();

    const requests = [];

    // This fixes some tests but breaks other things
    // return [];

    for (let page = 1; page <= pages; page++) {
      requests.push(
        request
          .get(`${panthorEndpoint}/menu/products/${organisationId}/${id}/page/${page}`, {
            retry,
            timeout,
            headers: {
              Authorization: `Bearer ${token}`,
              'x-api-apex-logging-project': process.env.POI_APP_LOGGER_PROJECT,
            },
          })
          .json(),
      );
    }

    const response = await Promise.all(requests);

    const products = response.flat(1);

    return products;
  } catch (err) {
    if (err instanceof HTTPError || err instanceof TimeoutError) throw err;
    logger.error('[@fingermarkglobal/restaurant] Error in getProductsRequest:', err);
    throw err;
  }
};

export { getProductsRequest };
